/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * センター・商品毎出荷予測
 * @export
 * @interface ShipExpected
 */
export interface ShipExpected {
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShipExpected
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipExpected
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipExpected
     */
    itemName: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShipExpected
     */
    centerName: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    expectedRank: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col1: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col2: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col3: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col4: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col5: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col6: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col7: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col8: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col9: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col10: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col11: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col12: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col13: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col14: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col15: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col16: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col17: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col18: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col19: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col20: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col21: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col22: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col23: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpected
     */
    col24: number | null;
}

/**
 * Check if a given object implements the ShipExpected interface.
 */
export function instanceOfShipExpected(value: object): value is ShipExpected {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('itemName' in value) || value['itemName'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('centerName' in value) || value['centerName'] === undefined) return false;
    if (!('expectedRank' in value) || value['expectedRank'] === undefined) return false;
    if (!('col1' in value) || value['col1'] === undefined) return false;
    if (!('col2' in value) || value['col2'] === undefined) return false;
    if (!('col3' in value) || value['col3'] === undefined) return false;
    if (!('col4' in value) || value['col4'] === undefined) return false;
    if (!('col5' in value) || value['col5'] === undefined) return false;
    if (!('col6' in value) || value['col6'] === undefined) return false;
    if (!('col7' in value) || value['col7'] === undefined) return false;
    if (!('col8' in value) || value['col8'] === undefined) return false;
    if (!('col9' in value) || value['col9'] === undefined) return false;
    if (!('col10' in value) || value['col10'] === undefined) return false;
    if (!('col11' in value) || value['col11'] === undefined) return false;
    if (!('col12' in value) || value['col12'] === undefined) return false;
    if (!('col13' in value) || value['col13'] === undefined) return false;
    if (!('col14' in value) || value['col14'] === undefined) return false;
    if (!('col15' in value) || value['col15'] === undefined) return false;
    if (!('col16' in value) || value['col16'] === undefined) return false;
    if (!('col17' in value) || value['col17'] === undefined) return false;
    if (!('col18' in value) || value['col18'] === undefined) return false;
    if (!('col19' in value) || value['col19'] === undefined) return false;
    if (!('col20' in value) || value['col20'] === undefined) return false;
    if (!('col21' in value) || value['col21'] === undefined) return false;
    if (!('col22' in value) || value['col22'] === undefined) return false;
    if (!('col23' in value) || value['col23'] === undefined) return false;
    if (!('col24' in value) || value['col24'] === undefined) return false;
    return true;
}

export function ShipExpectedFromJSON(json: any): ShipExpected {
    return ShipExpectedFromJSONTyped(json, false);
}

export function ShipExpectedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipExpected {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'orgItemCode': json['org_item_code'],
        'itemCode': json['item_code'],
        'itemName': json['item_name'],
        'centerId': json['center_id'],
        'centerName': json['center_name'],
        'expectedRank': json['expected_rank'],
        'col1': json['col1'],
        'col2': json['col2'],
        'col3': json['col3'],
        'col4': json['col4'],
        'col5': json['col5'],
        'col6': json['col6'],
        'col7': json['col7'],
        'col8': json['col8'],
        'col9': json['col9'],
        'col10': json['col10'],
        'col11': json['col11'],
        'col12': json['col12'],
        'col13': json['col13'],
        'col14': json['col14'],
        'col15': json['col15'],
        'col16': json['col16'],
        'col17': json['col17'],
        'col18': json['col18'],
        'col19': json['col19'],
        'col20': json['col20'],
        'col21': json['col21'],
        'col22': json['col22'],
        'col23': json['col23'],
        'col24': json['col24'],
    };
}

export function ShipExpectedToJSON(json: any): ShipExpected {
    return ShipExpectedToJSONTyped(json, false);
}

export function ShipExpectedToJSONTyped(value?: ShipExpected | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'org_item_code': value['orgItemCode'],
        'item_code': value['itemCode'],
        'item_name': value['itemName'],
        'center_id': value['centerId'],
        'center_name': value['centerName'],
        'expected_rank': value['expectedRank'],
        'col1': value['col1'],
        'col2': value['col2'],
        'col3': value['col3'],
        'col4': value['col4'],
        'col5': value['col5'],
        'col6': value['col6'],
        'col7': value['col7'],
        'col8': value['col8'],
        'col9': value['col9'],
        'col10': value['col10'],
        'col11': value['col11'],
        'col12': value['col12'],
        'col13': value['col13'],
        'col14': value['col14'],
        'col15': value['col15'],
        'col16': value['col16'],
        'col17': value['col17'],
        'col18': value['col18'],
        'col19': value['col19'],
        'col20': value['col20'],
        'col21': value['col21'],
        'col22': value['col22'],
        'col23': value['col23'],
        'col24': value['col24'],
    };
}

